import JsonResource from "@/types/interfaces/JsonResource";

export interface IOptionUpdate {
  option_id: number;
  selected_dates: string[];
}

export interface IContractUpdatePartial {
  contract_id: string;
  new_options: IOptionUpdate[];
  removed_options: IOptionUpdate[];
}


export interface IPostPaymentRequestBody {
  reservationId: string,
  paymentMethod: string,
  returnUrl: string,
  contractUpdates: IContractUpdatePartial[]
}

export class ContractUpdatePartial implements JsonResource {
  public contractId: string;
  public newOptions: IOptionUpdate[];
  public removedOptions: IOptionUpdate[];

  constructor(data: IContractUpdatePartial) {
    this.contractId = data.contract_id;
    this.newOptions = data.new_options;
    this.removedOptions = data.removed_options;
  }

  toJsonObject(): Record<string, unknown> {
    return {
      contract_id: this.contractId,
      new_options: this.newOptions.map(option => ({
        option_id: option.option_id,
        selected_dates: option.selected_dates ?? []
      })),
      removed_options: this.removedOptions.map(option => ({
        option_id: option.option_id,
        selected_dates: option.selected_dates ?? []
      }))
    };
  }


  toJsonString(): string {
    return JSON.stringify(this.toJsonObject());
  }
}

export default class PostPaymentData implements JsonResource {
  public reservationId: string;
  public paymentMethod: string;
  public returnUrl: string;
  public contractUpdates: ContractUpdatePartial[];

  constructor(data: IPostPaymentRequestBody) {
    this.reservationId = data.reservationId;
    this.paymentMethod = data.paymentMethod;
    this.returnUrl = data.returnUrl;
    this.contractUpdates = data.contractUpdates.map(cu => new ContractUpdatePartial(cu));
  }

  toJsonObject(): Record<string, unknown> {
    return {
      reservation_id: this.reservationId,
      payment_method: this.paymentMethod,
      return_url: this.returnUrl,
      contract_updates: this.contractUpdates.map(cu => cu.toJsonObject())
    };
  }

  toJsonString(): string {
    return JSON.stringify(this.toJsonObject());
  }
}
